import styled from "styled-components";

export const SliderContainer = styled.div`
  position: relative;
  padding: 10px 0 30px;

  .swiper {
    width: 100%;
    padding-bottom: 40px;
  }

  .swiper-pagination {
    bottom: 0;
  }

  .swiper-pagination-bullet {
    background: #a5b5af;
    opacity: 1;
    width: 10px;
    height: 10px;
    margin: 0 5px;
    transform: scale(1) !important;
  }

  .swiper-pagination-bullet-active {
    background: #2ecf96;
    transform: scale(1) !important;
  }
`;

export const TestimonialCard = styled.div`
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const TestimonialHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const ProfileImageWrapper = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-right: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const TestimonialUser = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Stars = styled.div`
  color: #ffc107;
  font-size: 18px;
  margin-bottom: 5px;
`;

export const UserName = styled.h3`
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  color: #333;
`;

export const UserAge = styled.p`
  font-size: 14px;
  color: #666;
  margin: 5px 0 0;
`;

export const TestimonialText = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: #444;
  margin: 0;
`;

export const CustomNavigation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  .swiper-button-prev.custom,
  .swiper-button-next.custom {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    background: none;
    color: #2ecf96;

    &::after {
      content: none;
    }
  }

  .swiper-pagination {
    position: static;
    width: auto;
  }
`;
export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Title = styled.h3`
  font-size: 18px;
  color: #142c1f;
`;
